"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reduceDictionary = void 0;
/**
 * Transform a dictionary into a new type
 * @public
 *
 * @param reducer - The function to be applied for every key
 * @param input - The input dictionary to be transformed
 * @param initialValue - The initial value to start running the reducer function
 *
 * @returns A new object depending on the reducer function
 *
 * @example
 * ```ts
 * const config = {
 *   key: 'value',
 *   key2: 'value2',
 * }
 * const result = reduceDictionary(
 *   (acc, item, key) => acc + item,
 *   config
 *   '',
 * );
 * console.log(result);
 * // -> 'valuevalue2'
 * ```
 */
function reduceDictionary(reducer, input, initialValue) {
    let acc = initialValue;
    for (const key in input) {
        if (Object.prototype.hasOwnProperty.call(input, key)) {
            acc = reducer(acc, input[key], key);
        }
    }
    return acc;
}
exports.reduceDictionary = reduceDictionary;
//# sourceMappingURL=reduce-dictionary.js.map